import styled from '@emotion/styled';

export const Label = styled.span<{ active: boolean }>`
  color: ${({ active }) => (active ? '#6E4C7D' : '#636363')};
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
